import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 loader.
 *
 * Requires env var set in /app/frontend/.env (optional — fallback to no-op):
 *   REACT_APP_GA4_MEASUREMENT_ID=G-XXXXXXXXXX
 *
 * Note: Google Search Console verification meta tag is set statically in
 * public/index.html (so it is visible to crawlers without executing JS).
 *
 * Tracks SPA route changes automatically.
 */
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";

let injected = false;

function injectGA4() {
  if (injected || !GA4_ID) return;
  injected = true;

  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s1);

  const s2 = document.createElement("script");
  s2.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
window.gtag = gtag;
gtag('js', new Date());
gtag('config', '${GA4_ID}', { send_page_view: false });`;
  document.head.appendChild(s2);
}

export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    injectGA4();
  }, []);

  useEffect(() => {
    if (!GA4_ID || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
